import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CustomSelect from '@components/CustomSelect/CustomSelect';
import { LanguageKey, LanguageMap } from '@models/common';
import { IRootState } from '@store/reducers';
import { setLanguage } from '@store/reducers/preferencesSlice';

import type { AppDispatch } from '@store/index';

function LanguageSelect() {
  const language = useSelector(
    (state: IRootState) => state.preferencesSlice.language,
  );
  const dispatch = useDispatch<AppDispatch>();

  return (
    <CustomSelect
      value={language}
      placeholder=""
      options={(
        Object.keys(LanguageMap) as Array<keyof typeof LanguageMap>
      ).map((langKey) => ({
        label: LanguageMap[langKey].label,
        value: langKey,
      }))}
      onChange={(value: LanguageKey) => {
        dispatch(setLanguage(value));
      }}
    />
  );
}

export default LanguageSelect;
